module.exports = __webpack_public_path__ + "static/img/imgTmp.4fcad59b.png";